import fhirpath from 'fhirpath';

export const createTransactionBundle = (resources: any[]): any => {
  return {
    resourceType: 'Bundle',
    type: 'transaction',
    entry: resources.map((resource) => ({
      resource,
      request: {
        method: resource.id ? 'PUT' : 'POST',
        url: resource.id ? `${resource.resourceType}/${resource.id}` : resource.resourceType,
      },
    })),
  };
};

export const downloadJson = (data: any, fileName: string) => {
  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const mapResourcesWithFhirPath = (resources: any[], mapping: Record<string, string>): any[] => {
  return resources.map((resource) => {
    const row: Record<string, string> = {};
    Object.entries(mapping).forEach(([header, path]) => {
      const result = fhirpath.evaluate(resource, path);
      row[header] = result
        .map((item) =>
          typeof item === 'object' && item !== null 
            ? JSON.stringify(item) 
            : item
        )
        .join(', ');
    });
    return row;
  });
};

export const downloadCsv = (data: any[], fileName: string) => {
  if (data.length === 0) return;

  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(','),
    ...data.map((row) =>
      headers
        .map((header) => {
          const cell = row[header] === null || row[header] === undefined ? '' : row[header];
          return `"${String(cell).replace(/"/g, '""')}"`;
        })
        .join(',')
    ),
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};